//Gateway value
export const GET_GATEWAYS_REQUESTED = 'GET_GATEWAYS_REQUESTED';
export const GET_GATEWAYS_SUCCESS   = 'GET_GATEWAYS_SUCCESS';
export const GET_GATEWAYS_FAILED    = 'GET_GATEWAYS_FAILED';
